import React from "react";
import PropTypes from 'prop-types';
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { darken } from "@material-ui/core/styles";
import "./SolutionArticleSummaryCard.scss";

export default function SolutionArticleSummaryCard(props) {

  const {callToAction, image, mobileImage, title, subtitle, paragraph } = props.data;

  const useStyles = makeStyles(theme => ({
    cardImage: {
      backgroundImage: `url("${image}")`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"
    },
    textColor: {
      color: theme.palette.primary.main,
    },
    buttonColor: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      '&:hover': {
        color: "#fff",
        backgroundColor: darken(theme.palette.primary.main, 0.2),
      },
      '&:focus': {
        color: "#fff",
        backgroundColor: darken(theme.palette.primary.main, 0.2),
        outline: "none"
      }
    }
  }));

  const classes = useStyles();

  return (
    <div className="card-wrapper">
      <div className={`image-container ${classes.cardImage}`}></div>
      <div className="content-container">
        <div className="content-group">
          <h3 className={`${classes.textColor}`}>{title}</h3>
          <h4>{subtitle}</h4>
          <p>{paragraph}</p>
        </div>
        <div className="action-container">
          {callToAction.map((item, index) => 
              <Button 
                key={index} 
                variant="contained" 
                size="large" 
                className={`btn-sm ${classes.buttonColor}`} onClick={() => props.scrollToElement(item.anchor)}>{item.buttonTitle}</Button>)
          }
        </div>
      </div>
    </div>
  )
}

SolutionArticleSummaryCard.propTypes = {
  data: PropTypes.shape({
    callToAction: PropTypes.string,
    image: PropTypes.string,
    mobileImage: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    paragraph: PropTypes.string,
  })
}


// WEBPACK FOOTER //
// ./src/components/LandingPages/SolutionsArticleSummary/SolutionArticleSummaryCard.js